// components/templates/sections/HeroSlider.tsx
'use client';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import Image from 'next/image';
import { useDesign } from '@/context/DesignContext';

interface Slide {
  image: string;
  title: string;
  subtitle: string;
  ctaText?: string;
  ctaLink?: string;
  phone?: string;
  phoneLabel?: string;
}

interface HeroSliderProps {
  slides: Slide[];
  design?: any;
}

export default function HeroSlider({ slides, design: propDesign }: HeroSliderProps) {
  const contextDesign = useDesign();
  const design = propDesign || contextDesign;

  // Extract values with fallbacks
  const titleFont = design?.typography?.headingFont || "'Sora', sans-serif";
  const subtitleFont = design?.typography?.bodyFont || "'Plus Jakarta Sans', sans-serif";
  const ctaButton = design?.buttons?.secondary || {
    class: 'tf-button style2',
    backgroundColor: 'transparent',
    borderColor: 'var(--primary)',
    textColor: 'var(--primary)',
    borderRadius: '30px',
    padding: '12px 30px'
  };
  const paginationColor = design?.colors?.primary || '#E07A5F';
  const overlayBackground = design?.colors?.primary || '#E07A5F';

  // Inline styles
  const titleStyle = {
    fontFamily: titleFont,
    fontWeight: 'bold',
    marginBottom: '0.5rem',
  };
  const subtitleStyle = {
    fontFamily: subtitleFont,
    fontSize: '1.2rem',
    marginBottom: '1.5rem',
  };
  const ctaButtonStyle = {
    backgroundColor: ctaButton.backgroundColor,
    border: ctaButton.borderColor ? `1px solid ${ctaButton.borderColor}` : 'none',
    color: ctaButton.textColor,
    padding: ctaButton.padding,
    borderRadius: ctaButton.borderRadius,
    cursor: 'pointer',
    textDecoration: 'none',
    display: 'inline-block',
  };
  const paginationStyle = `
    .swiper-pagination-bullet-active {
      background: ${paginationColor} !important;
    }
  `;
  const overlayStyle = {
    position: 'relative' as const,
    '--overlay-color': overlayBackground,
  };

  return (
    <>
      <style>{paginationStyle}</style>
      <Swiper
        modules={[Pagination, Autoplay]}
        pagination={{ clickable: true, el: '.pagination-swiper1' }}
        autoplay={{ delay: 5000 }}
        loop
        className="mySwiper"
      >
        {slides.map((slide, idx) => (
          <SwiperSlide key={idx}>
            <div className="overlay" style={overlayStyle}>
              <Image src={slide.image} alt="" width={1920} height={800} />
            </div>
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className="box-slider">
                    <div className="content-box">
                      <h2 className="title" style={titleStyle}>{slide.title}</h2>
                      <p className="sub-title" style={subtitleStyle}>{slide.subtitle}</p>
                      <div className="wrap-btn">
                        <a href={slide.ctaLink || '/menu'} className={ctaButton.class} style={ctaButtonStyle}>
                          {slide.ctaText || 'discovery menu'}
                        </a>
                      </div>
                    </div>
                    <div className="contact-info">
                      <div className="icon">
                        <svg />
                      </div>
                      <div className="left">
                        <h6>{slide.phoneLabel || 'call us book a table & delivery'}</h6>
                        <h4>{slide.phone || '978-212-8600'}</h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
        <div className="swiper-pagination pagination-swiper1"></div>
      </Swiper>
    </>
  );
}